export const templateFn = function anonymous(locals, escapeFn, include, rethrow
) {
"use strict";
rethrow = rethrow || function rethrow(err, str, flnm, lineno, esc) {
  var lines = str.split('\n');
  var start = Math.max(lineno - 3, 0);
  var end = Math.min(lines.length, lineno + 3);
  var filename = esc(flnm);
  // Error context
  var context = lines.slice(start, end).map(function (line, i){
    var curr = i + start + 1;
    return (curr == lineno ? ' >> ' : '    ')
      + curr
      + '| '
      + line;
  }).join('\n');

  // Alter exception message
  err.path = filename;
  err.message = (filename || 'ejs') + ':'
    + lineno + '\n'
    + context + '\n\n'
    + err.message;

  throw err;
};
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
var __line = 1
  , __lines = "<div class=\"nb-menu-dropdown nb-menu-dropdown--switcher nb-menu-dropdown--<%= $ctrl.active ? 'open' : 'closed' %>\"\n  role=\"region\"\n  aria-label=\"<%= t('SWITCHER.organizations') %>\"\n>\n  <div class=\"nb-menu-container\">\n    <div class=\"nb-menu-body\">\n      <% if (!$ctrl.fetchedTeams) { %>\n        <svg class=\"nb-spinner\" aria-label=\"<%= t('SPINNER.loading')%>\">\n          <title><% t('SPINNER.loading')%></title>\n          <use xmlns:xlink=\"http://www.w3.org/1999/xlink\" xlink:href=\"#svg-spinner\"></use>\n        </svg>\n      <% } else if ($ctrl.menus.length <= 0)  { %>\n        <div class=\"nb-menu-empty-state\" >\n          <h2 class=\"nb-menu-empty-state__main\"><%= t('SWITCHER.empty_title') %></h2>\n          <p class=\"nb-menu-empty-state__sub\"><%= t('SWITCHER.empty_description') %></p>\n        </div>\n      <% } else { %>\n        <% $ctrl.menus.forEach(function(menu, index) { %>\n          <div class=\"nb-list\">\n            <span class=\"nb-list__header\" aria-hidden=\"true\" id=\"switcher-list-header-<%= index %>\">\n              <%= menu.title %>\n            </span>\n            <div class=\"nb-list__items\" role=\"list\" aria-labelledby=\"switcher-list-header-<%= index %>\">\n              <% menu.items.slice(0, menu.showCount).forEach(function(item, i) { %>\n                <a nb-close-dropdown class=\"nb-list-item--clickable\" href=\"<%= item.url %>\" target=\"_self\"\n                  nb-event=\"ContextSwitcher:Click:View<%= menu.key %>:<%= (i + 1) %>\"\n                  role=\"listitem\"\n                  aria-labelledby=\"switcher-listitem-title-<%= menu.key %>-<%= i %>\">\n                  <span class=\"nb-list-item__avatar\" aria-hidden=\"true\">\n                    <%- item.avatar %>\n                  </span>\n                  <span class=\"nb-list-item__summary\">\n                    <div class=\"nb-list-item__header\">\n                      <span class=\"nb-list-item__title\" id=\"switcher-listitem-title-<%= menu.key %>-<%= i %>\">\n                        <%= item.title %>\n                      </span>\n                      <% if (item.subtitle && item.originator_system === 'Ngin') { %>\n                        <span class=\"nb-list-item__subtitle\"><%= item.subtitle %></span>\n                      <% } %>\n                    </div>\n                    <% if (item.descriptionList && item.originator_system === 'Ngin') { %>\n                      <ul class=\"nb-list-item__description-list\" >\n                        <% item.descriptionList.forEach(function(description) { %>\n                          <li><%= description %></li>\n                        <% }) %>\n                      </ul>\n                    <% } %>\n                  </span>\n                </a>\n              <% }) %>\n            </div>\n            <% if (menu.items.length >= menu.viewAllThreshold) { %>\n              <div class=\"nb-list__footer\">\n                <a nb-close-dropdown href=\"<%= menu.viewAllUrl %>?<%= $ctrl.referrerConfigParams %>\" target=\"_self\" class=\"nb-link-2\" nb-event=\"ContextSwitcher:Click:ViewAll<%= menu.key %>\"><%= menu.viewAll %></a>\n              </div>\n            <% } %>\n          </div>\n        <% }) %>\n      <% } %>\n    </div>\n  </div>\n</div>\n"
  , __filename = undefined;
try {
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  var __locals = (locals || {}),
$ctrl = __locals.$ctrl,
  config = __locals.config,
  formatDate = __locals.formatDate,
  hasTouch = __locals.hasTouch,
  initializeCSSVars = __locals.initializeCSSVars,
  initialsFromFullName = __locals.initialsFromFullName,
  multiToggleFactory = __locals.multiToggleFactory,
  t = __locals.t,
  htmlWebpackPlugin = __locals.htmlWebpackPlugin;
    ; __append("<div class=\"nb-menu-dropdown nb-menu-dropdown--switcher nb-menu-dropdown--")
    ; __append(escapeFn( $ctrl.active ? 'open' : 'closed' ))
    ; __append("\"\n  role=\"region\"\n  aria-label=\"")
    ; __line = 3
    ; __append(escapeFn( t('SWITCHER.organizations') ))
    ; __append("\"\n>\n  <div class=\"nb-menu-container\">\n    <div class=\"nb-menu-body\">\n      ")
    ; __line = 7
    ;  if (!$ctrl.fetchedTeams) { 
    ; __append("\n        <svg class=\"nb-spinner\" aria-label=\"")
    ; __line = 8
    ; __append(escapeFn( t('SPINNER.loading')))
    ; __append("\">\n          <title>")
    ; __line = 9
    ;  t('SPINNER.loading')
    ; __append("</title>\n          <use xmlns:xlink=\"http://www.w3.org/1999/xlink\" xlink:href=\"#svg-spinner\"></use>\n        </svg>\n      ")
    ; __line = 12
    ;  } else if ($ctrl.menus.length <= 0)  { 
    ; __append("\n        <div class=\"nb-menu-empty-state\" >\n          <h2 class=\"nb-menu-empty-state__main\">")
    ; __line = 14
    ; __append(escapeFn( t('SWITCHER.empty_title') ))
    ; __append("</h2>\n          <p class=\"nb-menu-empty-state__sub\">")
    ; __line = 15
    ; __append(escapeFn( t('SWITCHER.empty_description') ))
    ; __append("</p>\n        </div>\n      ")
    ; __line = 17
    ;  } else { 
    ; __append("\n        ")
    ; __line = 18
    ;  $ctrl.menus.forEach(function(menu, index) { 
    ; __append("\n          <div class=\"nb-list\">\n            <span class=\"nb-list__header\" aria-hidden=\"true\" id=\"switcher-list-header-")
    ; __line = 20
    ; __append(escapeFn( index ))
    ; __append("\">\n              ")
    ; __line = 21
    ; __append(escapeFn( menu.title ))
    ; __append("\n            </span>\n            <div class=\"nb-list__items\" role=\"list\" aria-labelledby=\"switcher-list-header-")
    ; __line = 23
    ; __append(escapeFn( index ))
    ; __append("\">\n              ")
    ; __line = 24
    ;  menu.items.slice(0, menu.showCount).forEach(function(item, i) { 
    ; __append("\n                <a nb-close-dropdown class=\"nb-list-item--clickable\" href=\"")
    ; __line = 25
    ; __append(escapeFn( item.url ))
    ; __append("\" target=\"_self\"\n                  nb-event=\"ContextSwitcher:Click:View")
    ; __line = 26
    ; __append(escapeFn( menu.key ))
    ; __append(":")
    ; __append(escapeFn( (i + 1) ))
    ; __append("\"\n                  role=\"listitem\"\n                  aria-labelledby=\"switcher-listitem-title-")
    ; __line = 28
    ; __append(escapeFn( menu.key ))
    ; __append("-")
    ; __append(escapeFn( i ))
    ; __append("\">\n                  <span class=\"nb-list-item__avatar\" aria-hidden=\"true\">\n                    ")
    ; __line = 30
    ; __append( item.avatar )
    ; __append("\n                  </span>\n                  <span class=\"nb-list-item__summary\">\n                    <div class=\"nb-list-item__header\">\n                      <span class=\"nb-list-item__title\" id=\"switcher-listitem-title-")
    ; __line = 34
    ; __append(escapeFn( menu.key ))
    ; __append("-")
    ; __append(escapeFn( i ))
    ; __append("\">\n                        ")
    ; __line = 35
    ; __append(escapeFn( item.title ))
    ; __append("\n                      </span>\n                      ")
    ; __line = 37
    ;  if (item.subtitle && item.originator_system === 'Ngin') { 
    ; __append("\n                        <span class=\"nb-list-item__subtitle\">")
    ; __line = 38
    ; __append(escapeFn( item.subtitle ))
    ; __append("</span>\n                      ")
    ; __line = 39
    ;  } 
    ; __append("\n                    </div>\n                    ")
    ; __line = 41
    ;  if (item.descriptionList && item.originator_system === 'Ngin') { 
    ; __append("\n                      <ul class=\"nb-list-item__description-list\" >\n                        ")
    ; __line = 43
    ;  item.descriptionList.forEach(function(description) { 
    ; __append("\n                          <li>")
    ; __line = 44
    ; __append(escapeFn( description ))
    ; __append("</li>\n                        ")
    ; __line = 45
    ;  }) 
    ; __append("\n                      </ul>\n                    ")
    ; __line = 47
    ;  } 
    ; __append("\n                  </span>\n                </a>\n              ")
    ; __line = 50
    ;  }) 
    ; __append("\n            </div>\n            ")
    ; __line = 52
    ;  if (menu.items.length >= menu.viewAllThreshold) { 
    ; __append("\n              <div class=\"nb-list__footer\">\n                <a nb-close-dropdown href=\"")
    ; __line = 54
    ; __append(escapeFn( menu.viewAllUrl ))
    ; __append("?")
    ; __append(escapeFn( $ctrl.referrerConfigParams ))
    ; __append("\" target=\"_self\" class=\"nb-link-2\" nb-event=\"ContextSwitcher:Click:ViewAll")
    ; __append(escapeFn( menu.key ))
    ; __append("\">")
    ; __append(escapeFn( menu.viewAll ))
    ; __append("</a>\n              </div>\n            ")
    ; __line = 56
    ;  } 
    ; __append("\n          </div>\n        ")
    ; __line = 58
    ;  }) 
    ; __append("\n      ")
    ; __line = 59
    ;  } 
    ; __append("\n    </div>\n  </div>\n</div>\n")
    ; __line = 63
  return __output;
} catch (e) {
  rethrow(e, __lines, __filename, __line, escapeFn);
}

}; export default templateFn